import React from 'react';
import { useSelector } from 'react-redux';

const arrowHeadPath = 'M -6 -6 L 0 0 L -6 6';

const sigType = {
  '-': 'negative',
  '+': 'positive',
  0: 'neutral',
};
// connector arrow head
const SignalArrow = ({ signal }) => {
  const label = `${signal.connectFrom}>${signal.connectTo}`;
  const head = useSelector(
    state => state.document.present.arrowPositions?.arrowHeads[label],
  );
  const path = useSelector(
    state => state.document.present.arrowPositions.paths[label],
  );

  const sigClass = `canvas__signal_arrow canvas__signal_arrow__${
    sigType[signal.polarity]
  }`;
  return (
    <>
      {signal.polarity !== '0' && head && (
        <path
          className={sigClass}
          d={arrowHeadPath}
          transform={`translate(${head.position.x} ${head.position.y}) rotate(${head.rotation})`}
        />
      )}
      <path className={sigClass} d={path} />
    </>
  );
};

export default React.memo(SignalArrow);
